import { render, staticRenderFns } from "./menu-leaf.vue?vue&type=template&id=377a0d55&scoped=true"
import script from "./menu-leaf.vue?vue&type=script&lang=js"
export * from "./menu-leaf.vue?vue&type=script&lang=js"
import style0 from "./menu-leaf.vue?vue&type=style&index=0&id=377a0d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377a0d55",
  null
  
)

export default component.exports